// extracted by mini-css-extract-plugin
module.exports = {"root":"spinner_root__F4u2l","rotate-loader":"spinner_rotate-loader__1vtiu","rotate-loader-dash":"spinner_rotate-loader-dash__2rNKj"};